"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = exports.NotificationServiceImpl = exports.NotificationToastLevel = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const theme_1 = require("../theme");
const CSS = {
    container: 'c-Notification-Toast',
    text: 'mdl-snackbar__text',
    button: 'mdl-snackbar__action',
    message: 'dgn-notification__message',
    isActive: 'mdl-snackbar--active',
    error: 'c-Notification-Toast--error',
    success: 'c-Notification-Toast--success',
    warn: 'c-Notification-Toast--warn',
    MDL: {
        container: 'dgn-notification mdl-snackbar',
    },
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        'z-index': 999,
        'border-radius': '4px',
    },
    [CSS.error]: {
        'border-left': '4px solid #d32f2f',
        background: '#424242',
    },
    [CSS.success]: {
        'border-left': '4px solid #4caf50',
        background: '#424242',
    },
    [CSS.warn]: {
        'border-left': '4px solid #ff9800',
        background: '#424242',
    },
});
var NotificationToastLevel;
(function (NotificationToastLevel) {
    NotificationToastLevel[NotificationToastLevel["SUCCESS"] = 0] = "SUCCESS";
    NotificationToastLevel[NotificationToastLevel["INFO"] = 1] = "INFO";
    NotificationToastLevel[NotificationToastLevel["WARN"] = 2] = "WARN";
    NotificationToastLevel[NotificationToastLevel["ERROR"] = 3] = "ERROR";
})(NotificationToastLevel || (exports.NotificationToastLevel = NotificationToastLevel = {}));
const LEVEL_CSS_CLASS = {
    [NotificationToastLevel.ERROR]: CSS.error,
    [NotificationToastLevel.SUCCESS]: CSS.success,
    [NotificationToastLevel.WARN]: CSS.warn,
    [NotificationToastLevel.INFO]: '',
};
const TOAST_TIMEOUT_MS = 3500;
class NotificationServiceImpl {
    constructor() {
        this.isOpen = false;
        this.level = NotificationToastLevel.INFO;
        this.timeout = null;
    }
    success(message) {
        this.message = message;
        this.level = NotificationToastLevel.SUCCESS;
        this.show();
    }
    info(message) {
        this.message = message;
        this.level = NotificationToastLevel.INFO;
        this.show();
    }
    warn(message) {
        this.message = message;
        this.level = NotificationToastLevel.WARN;
        this.show();
    }
    error(message) {
        this.message = message;
        this.level = NotificationToastLevel.ERROR;
        this.show();
    }
    errorAsString(message) {
        this.messageString = message;
        this.level = NotificationToastLevel.ERROR;
        this.show();
    }
    view() {
        const className = [CSS.container, CSS.MDL.container, LEVEL_CSS_CLASS[this.level], this.isOpen ? CSS.isActive : null]
            .filter(Boolean)
            .join(' ');
        var messageText = '';
        if (this.messageString) {
            messageText = this.messageString;
        }
        else if (this.message) {
            messageText = (0, i18n_1.Translate)(this.message.key, this.message.attrs);
        }
        return (0, mithril_1.m)('div', { className }, [(0, mithril_1.m)('div', { className: CSS.text }, messageText)]);
    }
    show() {
        if (this.timeout != null) {
            services_1.Services.Window.window.clearTimeout(this.timeout);
        }
        this.timeout = services_1.Services.Window.window.setTimeout((_) => this.hide(), TOAST_TIMEOUT_MS);
        this.isOpen = true;
    }
    hide() {
        if (this.timeout != null) {
            services_1.Services.Window.window.clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.isOpen = false;
    }
}
exports.NotificationServiceImpl = NotificationServiceImpl;
tslib_1.__decorate([
    mobx_1.observable
], NotificationServiceImpl.prototype, "message", void 0);
tslib_1.__decorate([
    mobx_1.observable
], NotificationServiceImpl.prototype, "messageString", void 0);
tslib_1.__decorate([
    mobx_1.observable
], NotificationServiceImpl.prototype, "isOpen", void 0);
tslib_1.__decorate([
    mobx_1.observable
], NotificationServiceImpl.prototype, "level", void 0);
tslib_1.__decorate([
    mobx_1.action
], NotificationServiceImpl.prototype, "show", null);
tslib_1.__decorate([
    mobx_1.action
], NotificationServiceImpl.prototype, "hide", null);
exports.NotificationService = new NotificationServiceImpl();
//# sourceMappingURL=notification.service.js.map